<script setup lang="ts">
/**
 * ProductPreviewModal — 상품군 발췌본 미리보기 뷰어(#341).
 *
 * `SampleViewerModal`(정적 URL 모드)에 상품군 설정(`data/productPreviews.ts`)을 꽂아 주는 얇은 래퍼다.
 * 구매 화면·랜딩이 URL·문구·이벤트 유형을 각자 들고 있지 않게 한다. 진입 버튼은 호출부 몫
 * (화면마다 버튼 스타일이 다르다) — 버튼은 `findProductPreview(groupCode)` 가 있을 때만 그린다.
 *
 * 자체 열람 이벤트는 뷰어가 로드 시 보내고, GA4 는 진입 지점을 알 수 있는 여기서 열림 전이마다 1회 보낸다.
 */
import { computed, watch } from 'vue';

import SampleViewerModal from '#/components/fo/SampleViewerModal.vue';
import { findProductPreview } from '#/data';
import { trackViewProductPreview, type ProductPreviewPlacement } from '#/lib/analytics';

interface Props {
  open: boolean;
  /** 카탈로그 상품군 code(config/catalog.ts 상수). */
  groupCode: string;
  /** GA4 진입 지점. */
  placement: ProductPreviewPlacement;
}

const props = defineProps<Props>();

const emit = defineEmits<{
  'update:open': [value: boolean];
}>();

const preview = computed(() => findProductPreview(props.groupCode));

watch(
  () => props.open,
  (isOpen) => {
    if (isOpen && preview.value) trackViewProductPreview(props.groupCode, props.placement);
  },
);
</script>

<template>
  <SampleViewerModal
    v-if="preview"
    :open="open"
    :sample="null"
    :static-url="preview.url"
    :static-title="preview.title"
    :static-note="preview.note"
    :view-event="preview.viewEvent"
    @update:open="emit('update:open', $event)"
  />
</template>
